import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "m-priceLevel__section -verticallyAligned" }
const _hoisted_3 = { class: "m-priceLevel__title" }
const _hoisted_4 = {
  key: 0,
  class: "m-priceLevel__description"
}
const _hoisted_5 = {
  "data-qa": 'price-level',
  class: "m-priceLevel__section"
}
const _hoisted_6 = {
  key: 0,
  class: "m-priceLevelIndicator"
}
const _hoisted_7 = { class: "m-priceLevel__section" }
const _hoisted_8 = {
  key: 1,
  class: "m-priceLevel__section"
}
const _hoisted_9 = {
  key: 0,
  class: "m-priceLevel__status"
}
const _hoisted_10 = { class: "m-priceLevel__pricePrimary" }
const _hoisted_11 = {
  key: 0,
  class: "m-priceLevel__pricePrimary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TicketTypeComponent = _resolveComponent("TicketTypeComponent")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_TicketFeeInfo = _resolveComponent("TicketFeeInfo")!
  const _directive_translate = _resolveDirective("translate")!

  return (_ctx.ticketTypes && _ctx.priceLevelState)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-qa": _ctx.PerformanceQASelectors.PRICE_LEVEL,
        class: _normalizeClass(["m-priceLevel", {
            '-is-disabled' : !_ctx.isAvailable,
            '-is-open': _ctx.priceLevelState && _ctx.priceLevelState.open && _ctx.isAvailable }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.priceLevelState.text), 1),
          (_ctx.priceLevelState.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.priceLevelState.description), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isAvailable)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_TransitionGroup, {
                  name: "staggered-fade",
                  tag: "div",
                  css: false,
                  onBeforeEnter: _ctx.beforeEnter,
                  onEnter: _ctx.enter,
                  onLeave: _ctx.leave
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketTypes, (ticketType, index) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_TicketTypeComponent, {
                        key: ticketType.ticketTypeID,
                        data: ticketType,
                        "connected-price-level": _ctx.data.priceLevelId
                      }, null, 8, ["data", "connected-price-level"])), [
                        [_vShow, _ctx.canDisplayTicketType(index)]
                      ])
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["onBeforeEnter", "onEnter", "onLeave"]),
                (_ctx.ticketTypes.length > 1 && _ctx.priceLevelState && !_ctx.priceLevelState.alwaysOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (!_ctx.priceLevelState.open)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "m-priceLevelIndicator__content",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.bestSeatStore.togglePriceLevelDisplay(_ctx.priceLevelState)), ["stop"])),
                            onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleKeyPress($event, _ctx.priceLevelState))),
                            tabindex: "0"
                          }, [
                            _createVNode(_component_IconComponent, {
                              "icon-id": _ctx.IconName.Arrow
                            }, null, 8, ["icon-id"]),
                            _withDirectives((_openBlock(), _createElementBlock("span", null, [
                              _createTextVNode("Show all prices")
                            ])), [
                              [_directive_translate, { key: _ctx.Translation.Ticket_selection_show_all_prices_label }]
                            ]),
                            _createVNode(_component_IconComponent, {
                              "icon-id": _ctx.IconName.Arrow
                            }, null, 8, ["icon-id"])
                          ], 32))
                        : _createCommentVNode("", true),
                      (_ctx.priceLevelState.open)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.bestSeatStore.togglePriceLevelDisplay(_ctx.priceLevelState)), ["stop"])),
                            class: "m-priceLevelIndicator__content -is-open"
                          }, [
                            _createVNode(_component_IconComponent, {
                              "icon-id": _ctx.IconName.Arrow
                            }, null, 8, ["icon-id"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.canDisplaySubmitButtonFor(_ctx.priceLevelState))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      "data-qa": 'price-level-submit',
                      class: _normalizeClass([_ctx.CurrencyHandler.isSecondaryCurrencyDisplayed ? '-marginTop' : '', "m-priceLevel__action"])
                    }, [
                      _createVNode(_component_ButtonComponent, {
                        active: _ctx.priceLevelState.active && _ctx.priceLevelState.canSubmit,
                        "icon-name": _ctx.IconName.Cart,
                        label: _ctx.submitButtonLabel,
                        "secondary-label": _ctx.CurrencyHandler.displaySecondaryCurrency(_ctx.ticketsPrice),
                        onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.bestSeatStore.submitSelection({
                                state: _ctx.priceLevelState,
                                promotion: _ctx.promotionStore.activePromotion,
                                promotionCode: _ctx.promotionStore.promotionCode,
                                eventName: _ctx.eventName,
                            }))),
                        "qa-selector": _ctx.PerformanceQASelectors.PRICE_LEVEL_SUBMIT
                      }, null, 8, ["active", "icon-name", "label", "secondary-label", "qa-selector"]),
                      _createVNode(_component_TicketFeeInfo, {
                        "fee-list": _ctx.bestSeatStore.fees,
                        "ticket-price-list": _ctx.getPriceListOfSelectedTickets(),
                        "currency-handler": _ctx.CurrencyHandler,
                        "has-opacity": !_ctx.priceLevelState.active || !_ctx.priceLevelState.canSubmit
                      }, null, 8, ["fee-list", "ticket-price-list", "currency-handler", "has-opacity"])
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_ctx.ticketTypes && _ctx.ticketTypes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _withDirectives((_openBlock(), _createElementBlock("p", null, [
                      _createTextVNode("Prices starting at:")
                    ])), [
                      [_directive_translate, {
                    key: _ctx.Translation.Ticket_selection_start_price_label,
                    keyValues: JSON.stringify({ 'min-price': _ctx.CurrencyHandler.displayPrimaryCurrency(_ctx.minPrice) }),
                    identifierStart: '{',
                    identifierEnd: '}',
                }]
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass([_ctx.CurrencyHandler.isSecondaryCurrencyDisplayed ? '' : '-centered', "m-priceLevel__price"])
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.CurrencyHandler.displayPrimaryCurrency(_ctx.minPrice)), 1),
                      (_ctx.CurrencyHandler.isSecondaryCurrencyDisplayed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.CurrencyHandler.displaySecondaryCurrency(_ctx.minPrice)), 1))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("p", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.data.statusDescription), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}